import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';

import * as userService from '../../services/userService';
import auth from '../../services/authService';

export default function LoginForm(props) {
  const [apiError, setApiError] = useState(null);

  const handleSubmit = (event) => {
    setApiError(null);
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    handleLogin(data);
    //handleSignIn(data);
    // eslint-disable-next-line no-console
    /* console.log({
      email: data.get('email'),
      password: data.get('password'),
    }); */
  };

  const handleLogin = async (data) => {
    try {
      const response = await auth.login(data.get('email'), data.get('password'));
      console.log('handleRegister response', response);
      auth.loginWithJwt(response.accessToken);
      //window.location = '/';
    } catch (ex) {
      if (ex.response && ex.response.status >= 400) {
        setApiError(ex.response.data.message);
      }
    }
  };
  
  return (
    <Box
      sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component='h1' variant='h5'>
        Sign in
      </Typography>
      <Box component='form' onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
        {apiError && <Alert severity='error'>{apiError}</Alert>}
        <TextField margin='normal' required fullWidth id='email' label='Email Address' name='email' autoComplete='email' autoFocus />
        <TextField margin='normal' required fullWidth name='password' label='Password' type='password' id='password' autoComplete='current-password' />
        <FormControlLabel control={<Checkbox value='remember' color='primary' />} label='Remember me' />
        <Button type='submit' fullWidth variant='contained' sx={{ mt: 3, mb: 2 }}>
          Sign In
        </Button>
        <Grid container>
          <Grid item xs>
            <Link href='#' variant='body2'>
              Forgot password?
            </Link>
          </Grid>
          <Grid item>
            <Link href='signup' variant='body2'>
              {"Don't have an account? Sign Up"}
            </Link>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
